import { MainMenu, SubMenuType } from 'rangeConfig/@types';
import platform from 'rangeConfig/shared/utils/platform';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import {
  appliancesProductListConfig,
  fridgeProductListConfig,
  hobsProductListConfig,
  hoodsProductListConfig,
  ovensProductListConfig
} from './productListConfig';
import hobImage from './images/integratedHob.jpg';
import ovenImage from './images/integratedOven.jpg';
import extractorHoodImage from './images/extractorHood.jpg';
import fridgeImage from './images/fridge.jpg';
import dishwasherImage from './images/dishwasher.jpg';
import washingMachineImage from './images/washingMachine.jpg';
import ExtractorHoodTypeFilter from 'rangeConfig/knoxhult/widgets/typeFilters/ExtractorHoodTypeFilter';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';

const appliancesOptions = () => {
  return [
    {
      id: 'integrated-hobs',
      title: 'storageone.integratedHobsMenuTitle',
      image: hobImage,
      widgets: [
        {
          id: 'integrated-hobs-product-list',
          component: withProducts(ProductList, hobsProductListConfig)
        }
      ]
    },
    {
      id: 'integrated-ovens',
      title: 'storageone.integratedOvensMenuTitle',
      image: ovenImage,
      widgets: [
        {
          id: 'integrated-ovens-product-list',
          component: withProducts(ProductList, ovensProductListConfig)
        }
      ]
    },
    {
      id: 'extractor-hoods',
      title: 'storageone.extractorHoodsMenuTitle',
      image: extractorHoodImage,
      widgets: [
        {
          id: 'hood-type-filters',
          component: ExtractorHoodTypeFilter
        },
        {
          id: 'extractor-hoods-product-list',
          component: withProducts(ProductList, hoodsProductListConfig)
        }
      ]
    },
    {
      id: 'dishwashers',
      title: 'storageone.dishwashersMenuTitle',
      image: dishwasherImage,
      widgets: [
        {
          id: 'dishwasher-product-list',
          component: withProducts(ProductList, appliancesProductListConfig)
        }
      ]
    },
    {
      id: 'fridges',
      title: 'storageone.fridgefreezersMenuTitle',
      image: fridgeImage,
      widgets: [
        {
          id: 'fridge-product-list',
          component: withProducts(ProductList, fridgeProductListConfig)
        }
      ]
    },
    {
      id: 'washing-machines',
      title: 'storageone.washingMachinesMenuTitle',
      image: washingMachineImage,
      widgets: [
        {
          id: 'washing-machines-product-list',
          component: withProducts(ProductList, appliancesProductListConfig)
        }
      ]
    }
  ];
};

const widgets = {
  desktop: [],
  mobile: [
    {
      id: 'integrated-hobs',
      title: 'storageone.integratedHobsMenuTitle',
      component: withProducts(ProductSwiper, hobsProductListConfig)
    },
    {
      id: 'integrated-ovens',
      title: 'storageone.integratedOvensMenuTitle',
      component: withProducts(ProductSwiper, ovensProductListConfig)
    },
    {
      id: 'extractor-hoods-product-list',
      title: 'storageone.extractorHoodsMenuTitle',
      component: withProducts(ProductSwiper, hoodsProductListConfig)
    },
    {
      id: 'dishwasher-product-list',
      title: 'storageone.dishwashersMenuTitle',
      component: withProducts(ProductSwiper, appliancesProductListConfig)
    },
    {
      id: 'fridge-product-list',
      title: 'storageone.fridgefreezersMenuTitle',
      component: withProducts(ProductSwiper, fridgeProductListConfig)
    },
    {
      id: 'washing-machines-product-list',
      title: 'storageone.washingMachinesMenuTitle',
      component: withProducts(ProductSwiper, appliancesProductListConfig)
    }
  ]
};

const subMenu = {
  mobile: undefined,
  desktop: {
    type: SubMenuType.LIST,
    options: appliancesOptions()
  }
};

const filters = {
  desktop: [],
  mobile: []
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.appliances',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: filters[platform],
  widgets: widgets[platform],
  subMenu: subMenu[platform]
};

export default mainMenu;
